module.exports = __webpack_public_path__ + "img/8.95554e78.jpg";